module.exports = __webpack_public_path__ + "assets/images/rbyearend-10.jpg?v=46614882";